export default "__VITE_ASSET__BqCXtCYH__"